import { Tag, baseApi } from './base'

export type WhatsAppBinding = {
  phoneNumber: string
  linkedAt: string
  lastActivityAt?: string
}

export type WhatsAppBindingsResponse = {
  bindings: WhatsAppBinding[]
  businessPhoneNumber: string | null
}

export const whatsappApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWhatsAppBindings: builder.query<WhatsAppBindingsResponse, void>({
      query: () => ({
        url: '/whatsapp/me/bindings',
        method: 'GET',
      }),
      providesTags: [{ type: Tag.WHATSAPP_BINDING, id: 'LIST' }],
    }),
    revokeWhatsAppBinding: builder.mutation<{ success: true }, string>({
      query: (phoneNumber) => ({
        url: `/whatsapp/me/bindings/${encodeURIComponent(phoneNumber)}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: Tag.WHATSAPP_BINDING, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
})
